import * as Yup from 'yup'

export const createFormValidationSchema = (prompts, formValues) => {
  const shape = prompts.reduce((acc, question) => {
    let validator = Yup.string()

    if (question.minLength) validator = validator.min(question.minLength)
    if (question.maxLength) validator = validator.max(question.maxLength)
    if (question.type === 'Enum') {
      let options = question.options

      // Check if options is a string and parse it if necessary
      if (typeof options === 'string') {
        try {
          options = JSON.parse(options)
        } catch (error) {
          console.error('Error parsing options:', error)
        }
      }

      if (Array.isArray(options)) {
        validator = Yup.mixed().oneOf(options)
      } else {
        console.error('Expected options to be an array:', options)
      }
    }
    if (question.type === 'Number') validator = Yup.number().required()
    if (question.type === 'Date') validator = Yup.date().required()
    if (question.key === 'phase_description') {
      validator = Yup.array().of(
        Yup.object().shape({
          milestone: Yup.string().required('Milestone is required'),
          timeline: Yup.string().required('Timeline is required'),
        }),
      )
    }

    if (question.condition) {
      if (!question.condition(formValues)) {
        validator = validator.notRequired()
      } else {
        validator = validator.required('Required')
      }
    } else {
      validator = validator.required('Required')
    }

    acc[question.key] = validator
    return acc
  }, {})
  return Yup.object().shape(shape)
}
